import { SxProps, Theme } from '@mui/material'

export const accordionSx = ({
  isBeforeExpanded,
  isAfterExpanded,
}: {
  isBeforeExpanded: boolean
  isAfterExpanded: boolean
}): SxProps<Theme> => {
  let props = {}

  if (isBeforeExpanded) {
    props = {
      borderBottomLeftRadius: '0.8rem',
      borderBottomRightRadius: '0.8rem',
    }
  }

  if (isAfterExpanded) {
    props = {
      borderTopLeftRadius: '0.8rem',
      borderTopRightRadius: '0.8rem',
    }
  }

  return {
    border: `0.1rem solid #0000001F`,
    overflow: 'hidden',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&.Mui-expanded': {
      borderRadius: '0.8rem',
      borderBottom: 'none',
    },

    '&:last-of-type': {
      borderBottomLeftRadius: '0.8rem',
      borderBottomRightRadius: '0.8rem',
    },
    '&:first-of-type': {
      borderTopLeftRadius: '0.8rem',
      borderTopRightRadius: '0.8rem',
    },
    boxShadow:
      '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',

    ...props,
  }
}

export const accordionSummarySx: SxProps<Theme> = {
  padding: '0 1.2rem',
  '&.Mui-expanded': {
    borderBottom: (theme) => `0.1rem solid ${theme.palette.divider}`,
  },
}

export const accordionDetailsSx: SxProps<Theme> = {
  padding: '1.2rem',
}

export const expandMoreIconSx: SxProps<Theme> = {
  width: '2.4rem',
  height: '2.4rem',
}
